module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ghu7S"))).then(() => parcelRequire('cvs7o'));